import { Field, type FieldProps } from "formik";
import { type FunctionComponent } from "react";
import { FormattedMessage, type IntlShape, injectIntl } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import { Checkbox } from "../Checkbox/Checkbox";

import style from "./AreaTypeCheckboxField.module.scss";

type AreaTypeCheckboxFieldProps = {
  className?: string;
};

interface AreaTypeCheckboxFieldPropsInner extends AreaTypeCheckboxFieldProps {
  intl: IntlShape;
}

const AreaTypeCheckboxFieldInner: FunctionComponent<
  AreaTypeCheckboxFieldPropsInner
> = (props) => {
  return (
    <div className={props.className}>
      <Field name="areaType">
        {(fieldProps: FieldProps) => (
          <Checkbox
            name={fieldProps.field.name}
            value={fieldProps.field.value === "wet"}
            type="checkbox"
            className={style.checkbox}
            onChange={(value) => {
              fieldProps.form.setFieldValue(
                fieldProps.field.name,
                value ? "wet" : "dry"
              );
            }}
            label={<FormattedMessage id="room.areaTypeCheckbox" />}
          />
        )}
      </Field>
    </div>
  );
};

export const AreaTypeCheckboxField = compose<AreaTypeCheckboxFieldProps>(
  injectIntl
)(AreaTypeCheckboxFieldInner);
